module.exports = __webpack_public_path__ + "static/media/img.978fe695.svg";